import {MessageBase} from './message-base';
import {PublisherParameter} from '../DoraWidget/widget-base/data/publisher-parameter';
import {FixedSeriesInfo} from './data/fixed-series-info';
import {DataRow} from '../DoraData/data-row';

/**
 * Message to notify that some rows are unselected
 */
export class MessageRowsUnselected  extends MessageBase<MessageRowsUnselected> {
  private idRows: string[];

  constructor(idRows: string[]) {
    super(MessageRowsUnselected);

    this.idRows = idRows;
  }

  public get DataRows(): string[] {
    return this.idRows;
  }
}
